<div class="mat-dialog-container">
  <!-- 明細編輯開始 -->
  <div #head>
    <app-modal-header #modal_header [isDialog]="isDialog" [title]="title" [state]="srv.state" (onOkClick)="doOk($event)"
      (onCancelClick)="doCancel($event)">
    </app-modal-header>
  </div>
  <div class="jk-content">
    <div class="jk-grid-cols-4"> 
    <app-jktextarea  height="250px" 
 label="欄位排序" #SQLORDERCom  id="SQLORDER"  [(value)]="item.SQLORDER" placeholder="欄位排序"  [readonly]="isBrowse"     >
    </app-jktextarea>
    <app-jkedit  label="保留6" #SB105Com  id="SB105"  [(value)]="item.SB105" placeholder="保留6"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="保留5" #SB104Com  id="SB104"  [(value)]="item.SB104" placeholder="保留5"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="保留4" #SB103Com  id="SB103"  [(value)]="item.SB103" placeholder="保留4"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jktextarea  height="250px" 
 label="保留3" #SB102Com  id="SB102"  [(value)]="item.SB102" placeholder="保留3"  [readonly]="isBrowse"     >
    </app-jktextarea>
    <app-jktextarea  height="250px" 
 label="保留2" #SB101Com  id="SB101"  [(value)]="item.SB101" placeholder="保留2"  [readonly]="isBrowse"     >
    </app-jktextarea>
    <app-jktextarea  height="250px" 
 label="保留1" #SB100Com  id="SB100"  [(value)]="item.SB100" placeholder="保留1"  [readonly]="isBrowse"     >
    </app-jktextarea>
    <app-jktextarea  height="250px" 
 label="SQLReturn" #SQLRETURNCom  id="SQLRETURN"  [(value)]="item.SQLRETURN" placeholder="SQLReturn"  [readonly]="isBrowse"     >
    </app-jktextarea>
    <app-jkedit  label="主資料表" #MAINTABLECom  id="MAINTABLE"  [(value)]="item.MAINTABLE" [required]="true"  placeholder="主資料表"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jktextarea  height="250px" 
 label="WHERE參數設定" #MAPCom  id="MAP"  [(value)]="item.MAP" placeholder="WHERE參數設定"  [readonly]="isBrowse"     >
    </app-jktextarea>
    <app-jktextarea  height="250px" 
 label="顯示" #DISPLAYCom  id="DISPLAY"  [(value)]="item.DISPLAY" placeholder="顯示"  [readonly]="isBrowse"     >
    </app-jktextarea>
    <app-jktextarea  height="250px" 
 label="備註" #PSCom  id="PS"  [(value)]="item.PS" placeholder="備註"  [readonly]="isBrowse"     >
    </app-jktextarea>
    <app-jktextarea  height="250px" 
 label="SQLWhere" #SQLWHERECom  id="SQLWHERE"  [(value)]="item.SQLWHERE" placeholder="SQLWhere"  [readonly]="isBrowse"     >
    </app-jktextarea>
    <app-jktextarea  height="250px" 
 label="SQLSelect" #SQLSELECTCom  id="SQLSELECT"  [(value)]="item.SQLSELECT" placeholder="SQLSelect"  [readonly]="isBrowse"     >
    </app-jktextarea>
    <app-jkedit  label="標題" #TITLECom  id="TITLE"  [(value)]="item.TITLE" placeholder="標題"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="類別" #TYPECom  id="TYPE"  [(value)]="item.TYPE" placeholder="類別"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jktext  label="序號" [value]="item.ITEM"     >
    </app-jktext>

    </div>
  </div>
</div>